export const FLOOR_NAV_DATA_TESTID = "floornav";
export const FLOOR_NAV_WOMEN_FLOOR_ID = "women-floor";
export const FLOOR_NAV_MEN_FLOOR_ID = "men-floor";
